import React from "react";
import Navbar from "../connected/Navbar";
import Footer from "../connected/Footer";
import PrivacyBody from "../sections/privacySection/PrivacyBody";
import PageHeader from "../primitive/PageHeader";

const Privacy = () => {
  return (
    <div>
      <PageHeader browserTitle="Privacy | Smartcomply Seequre" />
      <Navbar />
      <PrivacyBody />
      <Footer />
    </div>
  );
};

export default Privacy;
